<template>
    <div id="route-settings">

      <div class="flex flex-sb">
        <h2>{{ $t('route.settings_title') }}</h2>
        <AppButton icon="close" @click="close" />
      </div>

      <div class="setting">
        <h4>{{ $t('route.vehicle') }}</h4>
        <InputSelectHorizontal v-model="settings.vehicle" :options="[
          {display: $t('vehicles.student_truck'), value: 'truck'},
          {display: $t('vehicles.car'), value: 'car'},
          /*{display: $t('vehicles.bike'), value: 'bike'},
          {display: $t('vehicles.foot'), value: 'foot'}*/
        ]" />
      </div>
      <p class="hint" v-if="settings.vehicle == 'truck'">Fartgrænser på 40 km/h ved tættere bebyggelse, 60 km/h på landevej, undgår motor- og motortrafikveje.</p>

      <div class="divider"></div>
      <div class="setting">
        <h4>{{ $t('route.method') }}</h4>
        <InputSelectHorizontal v-model="settings.custom" :options="[
          {display: $t('route.fastest'), value: false},
          {display: $t('route.custom'), value: true},
        ]" />
      </div>

      <div class="divider"></div>
      
      <div class="setting">
        <h4>{{ $t('route.start_time') }}</h4>
        <input v-model="settings.startTime" type="time" style="width:8rem" placeholder="tt:mm" />
      </div>
      
      <div class="setting">
        <h4>{{ $t('route.start_date') }}</h4>
        <input v-model="settings.startDate" type="date" style="width:12rem" />
      </div>

      <div class="divider"></div>

      <div class="setting">
        <h4>{{ $t('route.breaks') }}</h4>
        <InputSelectHorizontal v-model="breaks" :options="[
          {display: $t('route.no_breaks'), value: 'none'},
          {display: $t('route.fixed_breaks') ,value: 'fixed'},
          {display: $t('route.auto_breaks') ,value: 'auto'}
        ]" />
      </div>
      <template v-if="breaks == 'auto'">
        <p class="hint"><b>Automatisk pause:</b> Indtast rutens ønskede varighed. Pauser fordeles ligeligt udfra den resterende tid. Husk du altid kan ændre ét eller flere stops pause tid manuelt.</p>
        <div class="setting">
          <h4>{{ $t('route.time_limit') }}</h4>
          <div><input v-model="settings.timeLimit" style="width:5rem" type="number" :min="minTimeLimit" /> timer</div>
        </div>
      </template>
      <template v-if="breaks == 'fixed'">
        <p class="hint"><b>Fast pause:</b> Indtast et fast antal minutter hvert stop tillægges. Husk du altid kan ændre ét eller flere stops pause tid manuelt.</p>
        <div class="setting">
          <h4>{{ $t('route.break_time') }}</h4>
          <div><input v-model="settings.breakTime" style="width:5rem" type="number" min="0" /> min</div>
          <div v-if="false"><InputTime v-model="settings.breakTime" /></div>
        </div>
      </template>

      <div class="divider"></div>

      <div class="setting">
        <h4>{{ $t('route.private_route') }} <span class="plan-tag">PLUS</span></h4>
        <InputCheck isSwitch v-model="settings.private" />
      </div>
    </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, reactive, ref, watch } from 'vue'
import InputSelectHorizontal from '@/components/inputs/InputSelectHorizontal.vue'
import InputCheck from '@/components/inputs/InputCheck.vue'
import InputTime from '@/components/inputs/InputTime.vue'

import { store } from '@/store'
import { Route, RouteSettings } from '@/api/tripply/models'
import { compareObjects } from '@/api/tools'

export default defineComponent({
  name: 'RouteSettings',
  components: { InputSelectHorizontal, InputCheck, InputTime },
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true    
    }
  },
  setup(props) {
    const settings = reactive<RouteSettings>({ ...props.route.settings })
    settings.breakTime /= 60
    settings.timeLimit /= 3600

    const breaks = ref(
      settings.timeLimit > 0 ? 'auto' :
      settings.breakTime > 0 ? 'fixed' : 'none'
    )

    const minTimeLimit = computed(() => Math.ceil(props.route.durationDriving / 60 / 60))

    async function update() {
      const updatedSettings = {...settings}
      updatedSettings.breakTime *= 60
      updatedSettings.timeLimit *= 3600
      if (breaks.value == 'fixed') updatedSettings.timeLimit = 0
      if (breaks.value == 'none') {
        updatedSettings.timeLimit = 0
        updatedSettings.breakTime = 0
      } 
      const changes = compareObjects<RouteSettings>(props.route.settings, updatedSettings)
      store.route.updateSettings(props.route.id, changes)
    }

    watch(breaks, (type) => {
      if (type == 'auto' && settings.timeLimit == 0) {
        settings.timeLimit = minTimeLimit.value
      } 
      update()
    })

    watch(settings, () => {
      update()
    })

    function close() {
      store.ui.mutate(state => state.route.settingsDrawer = false)
    }

    return { settings, close, breaks, minTimeLimit }
  }
})
</script>

<style lang="scss" scoped>
.setting {
  margin: 1rem 0;
  justify-content: space-between;
  align-items: center;
  display: flex;
  h4 {
    margin: 0;
    font-size: .9375rem;
  }
}
</style>